module.exports = __webpack_public_path__ + "static/media/SFPS.61a36979.png";